'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaLoginController = function () {
  function WinresOmalomaLoginController($rootScope, $scope, omalomaService, $window) {
    _classCallCheck(this, WinresOmalomaLoginController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;

    this.$window = $window;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // logging_in - In the process of logging in.
    // must_change_password - Logged in. Must change password.
    // changing_password - Changing password.
    // in - Logged in.
    // not_a_customer - Logged in, but the user is not a customer. Rare situation.
    // logging_out - In process of logging out.
    this.setStatus('init', null, null);

    // A notice or an error to be displayed. Passed to i18next.
    // Example notice: Password changed, must log in with new password.
    // Example error: Login failed, check username and password.
    this.$scope.notice = null;
    this.$scope.error = null;

    this.email = "";
    this.password = "";
    this.oldPassword = "";
    this.newPassword = "";
  }

  _createClass(WinresOmalomaLoginController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.refreshStatus();
      this.$rootScope.$on('login', function () {
        return _this.refreshStatus();
      });
      this.$rootScope.$on('logout', function () {
        _this.refreshStatus();

        // Select "Kirjautuminen" -tab in WordPress.
        // Note: tab id may change.
        // TODO: Make Omaloma independent non WordPress web application.
        document.querySelector('a[href="#tab-1559551874116-7-8"]').click();
      });
      if (this.recoverLogin) {
        this.$scope.$on('account-recover-done', function (event, email, password) {
          _this.email = email;
          _this.password = password;
        });
      }
      //var login = document.querySelectorAll('winres-omaloma-login')[0];
      //login.attributes[0].value = this.$rootScope.winresConnectionName; // set real connection name to right top corner login.
    }
  }, {
    key: 'refreshStatus',
    value: function refreshStatus() {
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.setStatus('in');
        this.onLogin();
        this.redirectIfUrlGiven();
      } else if (this.omalomaService.isLoggedInAsNewCustomer()) {
        this.setStatus('must_change_password');
      } else if (this.omalomaService.isLoggedInAsSomeOtherUserType()) {
        this.setStatus('not_a_customer');
      } else {
        this.setStatus('out');
      }
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, notice, error) {
      this.$scope.status = status;
      console.log('[WOL] Set status to', status);
      if (notice !== undefined) {
        if (notice) console.log('[WOL] Notice:', notice);
        this.$scope.notice = notice;
      }
      if (error !== undefined) {
        if (error) console.log('[WOL] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'login',
    value: function login(email, password) {
      var _this2 = this;

      //this.connectionName = this.$rootScope.winresConnectionName;
      if (!this.connectionName) {
        console.error('[WOL] Connection name is "' + this.connectionName + '".');
        this.setStatus('out', null, 'malfunction');
      }
      this.setStatus('logging_in', null, null);
      var q = this.omalomaService.login(this.connectionName, email, password);
      q.then(function (result) {
        if (result) {
          _this2.refreshStatus();
          console.log('[WOL] Connection name OK, it is "' + _this2.connectionName + '".');
        } else {
          _this2.setStatus('out', null, 'login_failed_specific.DeniedInvalidCredentials');
        }
      }, function (error) {
        console.error('[WOL] Login error:', error);
        _this2.setStatus('out', null, 'login_failed_specific.' + error.data.LoginResultType);
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      var _this3 = this;

      this.setStatus('changing_password', null, null);
      var q = this.omalomaService.changePassword(oldPassword, newPassword);
      return q.then(function (success) {
        if (success) {
          _this3.password = "";
          _this3.setStatus('out', 'password_changed', null);
          _this3.logout();
        } else {
          _this3.setStatus('must_change_password', null, 'password_change_rejected');
        }
      }, function (error) {
        console.error('[WOL] Password change error:', error);
        _this3.setStatus('must_change_password', null, 'malfunction');
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.password = "";
      this.setStatus('logging_out', undefined, null);
      this.omalomaService.logout();
      this.$window.location.hash = '';
    }
  }, {
    key: 'redirectIfUrlGiven',
    value: function redirectIfUrlGiven() {
      if (this.redirectOnLogin) {
        this.$window.location.href = this.redirectOnLogin;
      } else {
        return;
      }
    }
  }]);

  return WinresOmalomaLoginController;
}();

WinresOmalomaLoginController.$inject = ['$rootScope', '$scope', 'omalomaService', '$window'];

_module3.default.component('winresOmalomaLogin', {
  template: require('./winresOmalomaLogin.html'),
  controller: WinresOmalomaLoginController,
  require: {},
  bindings: {
    connectionName: '@',
    onLogin: '&',
    redirectOnLogin: '@',
    recoverLogin: '@'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaLogin/winresOmalomaLogin.js
// module id = 343
// module chunks = 2